import {openVideoUrlInPlayer} from '../../components/Gallery/VideoPlayer';
import {scrollToElem}         from '../../utils/CommonUtils';

/**
 * @param {string} playerJsHook
 * @param {int} videoTimestamp
 * @param {bool} needLogin
 */
function run(playerJsHook, videoTimestamp, needLogin) {
	const containers = document.querySelectorAll(`.${playerJsHook}`);
	for (let i = 0; i < containers.length; i++) {
		const $container = containers[i];

		const videoUrls = JSON.parse($container.dataset.videoUrl);

		const videoUrl     = videoUrls.length > 0 ? videoUrls[0] : '';
		const pictureUrl   = $container.dataset['pictureUrl'];
		const videoId      = $container.dataset['videoId'];
		const hideBadge    = $container.dataset['hideBadge'];
		const premiumBadge = $container.dataset['showPremiumBadge'];
		const over18Badge  = $container.dataset['showOver18Badge'];


		openVideoUrlInPlayer(
			$container,
			videoUrl,
			[pictureUrl],
			false,
			false,
			null,
			false,
			null,
			videoTimestamp,
			null,
			videoId,
			'',
			false,
			!hideBadge,
			premiumBadge,
			over18Badge,
			true,
			null,
			'',
			false,
			needLogin // need login to see a video
		);
	}

	if (document.getElementById('video-detail')) {
		// default scroll to content
		scrollToElem('video-detail');
	}
}

export {run};
